import { Component, Injectable,Input,Output, EventEmitter } from '@angular/core';

@Injectable()
export class EventEmitterService {
  @Output() fire: EventEmitter<any> = new EventEmitter();
   @Output() badges: EventEmitter<any> = new EventEmitter();
   
   constructor() {
   }

   change(item: any) {
     this.fire.emit(item);
   }

   getEmittedValue() {
     return this.fire;
   }

   changeBadges(item: any) {
     this.badges.emit(item);
   }

   getBadgesEmittedValue() {
     return this.badges;
   }
  
} 


// WEBPACK FOOTER //
// ./src/app/components/base/util/event-emitter.service.ts